import axios from "axios";

const API = axios.create({ baseURL: "https://auth.americanacademyeg.us/api/v2" });
// const API = axios.create({ baseURL: "https://local.americanacademyeg.us/api/v2" });
// const API = axios.create({ baseURL: "http://localhost:5000/api/v2" }); // development

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).value[0].token
    }`;
  }
  return req;
});

export const logIn = (userData) => API.post("/session", userData);
export const createUser = (userData) => API.post("/user", userData);
export const deleteUser = (username) => API.delete(`/user/${username}`);

export const getAll = (page, search, edit, signal) =>
  API.get("/students", { params: { page, search, edit }, signal });
export const allForViewers = (page, search, edit) =>
  API.get("/studentsforviewers", { params: { page, search, edit } });

export const getType = (user, type, search) =>
  API.get(`/${user}/${type}`, { params: { search } });

export const submit = (data) => API.post("/submit", data);
export const getUsers = () => API.get("/users");

// receiver ({ receiver_name, receiver_national_id, receiver_phone }) is required when to === "mohe_validation"
export const forward = (student_id, from, to, user_action, receiver = {}) =>
  API.post(`/${from}forward`, { student_id, to, user_action, ...receiver });

export const forwardWithCount = (to, student_id, user_action, increase) =>
  API.post(`/invoice/forwardwithcount`, {
    to,
    student_id,
    user_action,
    increase,
  });

export const sendAuditing = (id, request_edit_user, request_edit) =>
  API.post("/send_issue", { id, request_edit_user, request_edit });

export const sendInvoice = (id, invoice_wait_user, invoice) =>
  API.post("/send_invoice", { id, invoice_wait_user, invoice });

export const sendScore = () => API.post("/send_score");

export const requestEdit = (student_id) =>
  API.post("/request_edit", { student_id });

export const editRequest = (student) =>
  API.put("/edit_in_request", { student });

export const acceptEdit = (student_id) =>
  API.post("/accept_edit", { student_id });

export const editForword = (student) => API.put("/edit", { student });

export const updateUnique = (id) => API.post("/update_unique", { id });

export const resetStudent = (student_id) => API.post("/reset", { student_id });

export const createInvoice = (invoice_data) =>
  API.post("/invoice/create", { invoice_data });

export const createAnotherInvoice = (invoice_data, user_action) =>
  API.post("/invoice/createanother", { invoice_data, user_action });

export const getInvoiceNumber = () => API.get("/invoice/number");

export const GetStInvNum = (student_id) =>
  API.post("/invoice/stinvnum", { student_id: student_id });

export const updateInvoiceNumber = (invoice_number) =>
  API.post("/invoice/number", { invoice_number });

// Add / edit the certificate receiver of a student in MOHE Validation or MOHE.
export const updateMoheReceiver = (student_id, receiver) =>
  API.post("/mohe/receiver", { student_id, ...receiver });

export const jumpToState = (student_id, to, user_action, receiver = {}) =>
  API.post("/jumpto", { student_id, to, user_action, ...receiver });

export const bulkForward = (to, student_ids, user_action, receiver = {}) =>
  API.post("/bulk/forward", { to, student_ids, user_action, ...receiver });

export const countState = () => API.get("/count");

export const deleteStudent = (student_id) =>
  API.delete("/delete/" + student_id);

export const changeCategory = (student_id, category) =>
  API.patch("/category", { student_id, category });

export const changeCategoryToSchool = (school_name) =>
  API.patch("/category/school", { school_name });

export const countCategroy = () => API.get("/category");

export const exportExcelState = (state) => API.post("/excelstate", { state });

export const exportAllExcel = () => API.get("/excel");

export const exportExcelMoe = () => API.get("/excelmoe");

export const exportExcelFinalMoe = () => API.get("/excelfinalmoe");

export const exportExcelAct1 = () => API.get("/excelactone");

export const exportExcelAct1MoePending = () => API.get("/excelact1moepending");

export const exportExcelAct2 = () => API.get("/excelacttwo");

export const exportExcelAct2MoePending = () => API.get("/excelact2moepending");

export const exportExcelDeliveryHold = () => API.get("/exceldeliveryhold");

export const getAramexSheet = () => API.get("/aramex_sheet");

export const saveAramexSheet = (rows, updated_user) =>
  API.post("/aramex_sheet", { rows, updated_user });

export const exportExcelMoeHold = () => API.get("/excelmoehold");
export const exportExcelAatcReview = () => API.get("/excelaatcreview");

export const exportTopAchieversReport = () =>
  API.get("/invoice/top_achievers/report");

// payment = { payment_method, payer_name, payer_phone } (every page but Invoice).
export const setTopAchiever = (id, top_achievers, payment) =>
  API.post("/invoice/top_achievers", { id, top_achievers, ...(payment || {}) });

// With params ({ page, pageSize, search, status, location }) → one page for the
// Top Achievers Guests screen; without → every student (Excel export).
export const getTopAchieversGuests = (params) =>
  API.get("/top_achievers/guests", params ? { params } : undefined);
// Mark a Top Achiever's guest list as confirmed (done), or reopen it.
export const confirmTopAchieversGuests = (student_id, confirmed) =>
  API.post("/top_achievers/guests/confirm", { student_id, confirmed });

// Saved school merges for the ACT Top Achievers Report. `scope` = the school
// names in the export being saved; only groups touching them are replaced.
export const getSchoolMerges = () => API.get("/school_merges");
export const saveSchoolMerges = (scope, groups) => API.put("/school_merges", { scope, groups });

export const saveTopAchieversGuests = (student_id, guests, event_location, original_guests, event_day) =>
  API.post("/top_achievers/guests", { student_id, guests, event_location, original_guests, event_day });

export const setTopAchieverEventLocation = (student_id, event_location) =>
  API.post("/top_achievers/event_location", { student_id, event_location });

export const getEfadaStudent = (id) =>
  API.get(`/efada/student/${encodeURIComponent(id)}`);

// Every generated Efada letter is uploaded so it shows up in Efada History.
export const saveEfadaFile = (formData) => API.post("/efada/files", formData);
export const getEfadaFiles = (page, search) =>
  API.get("/efada/files", { params: { page, search } });
export const downloadEfadaFile = (id) =>
  API.get(`/efada/files/${id}/download`, { responseType: "blob" });
// The letter exported to PDF by Word on the server — what the viewer shows.
export const viewEfadaPdf = (id) =>
  API.get(`/efada/files/${id}/pdf`, { responseType: "blob" });

export const getTopAchieversChanges = (since) =>
  API.get(`/top_achievers/changes${since ? `?since=${encodeURIComponent(since)}` : ""}`);

export const setTopAchieverComment = (student_id, comment, previous_comment) =>
  API.post("/top_achievers/comment", { student_id, comment, previous_comment });

export const exportAct1TopAchieversReport = (dateFrom, dateTo, scoreFrom = 30, scoreTo = 36, city = "", eventLocation = "") =>
  API.get(`/act1/top_achievers/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}&scoreFrom=${encodeURIComponent(scoreFrom)}&scoreTo=${encodeURIComponent(scoreTo)}&city=${encodeURIComponent(city)}&eventLocation=${encodeURIComponent(eventLocation)}`);

export const exportAct2TopAchieversReport = (dateFrom, dateTo, scoreFrom = 30, scoreTo = 36, city = "", eventLocation = "") =>
  API.get(`/act2/top_achievers/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}&scoreFrom=${encodeURIComponent(scoreFrom)}&scoreTo=${encodeURIComponent(scoreTo)}&city=${encodeURIComponent(city)}&eventLocation=${encodeURIComponent(eventLocation)}`);

export const exportAct1AllGradesReport = (dateFrom, dateTo, dateType = "auth") =>
  API.get(`/act1/all_grades/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}&dateType=${encodeURIComponent(dateType)}`);

export const exportAct2AllGradesReport = (dateFrom, dateTo, dateType = "auth") =>
  API.get(`/act2/all_grades/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}&dateType=${encodeURIComponent(dateType)}`);

export const exportUniversitiesReport = (dateFrom, dateTo) =>
  API.get(`/universities/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

export const exportAllInvoicesReport = (dateFrom, dateTo) =>
  API.get(`/invoice/all/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

// Students who paid a MOHE Statement, filtered by payment date.
export const exportMoheStatementReport = (dateFrom, dateTo) =>
  API.get("/mohe_statement/report", { params: { dateFrom, dateTo } });

export const exportShippingReport = (dateFrom, dateTo) =>
  API.get(`/invoice/shipping/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

export const exportRushReport = (dateFrom, dateTo) =>
  API.get(`/invoice/rush/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

export const exportMoheReport = (dateFrom, dateTo) =>
  API.get(`/mohe/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

export const exportBankTransferPayersReport = (dateFrom, dateTo) =>
  API.get("/invoice/bank_transfer/report", { params: { dateFrom, dateTo } });

export const exportCertificateReceiversReport = (dateFrom, dateTo) =>
  API.get(`/mohe/receivers/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

export const exportCollegesReport = (dateFrom, dateTo) =>
  API.get(`/colleges/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

export const exportSchoolsStateReport = (dateFrom, dateTo, states) =>
  API.get(
    `/schools/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}` +
      (states && states.length ? `&states=${encodeURIComponent(states.join(","))}` : "")
  );

export const exportMissingEnrollmentLettersReport = (dateFrom, dateTo) =>
  API.get(`/missing_enrollment_letters/report?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`);

export const getCountryActualCounts = () =>
  API.get("/country_actual_counts");

export const saveCountryActualCounts = (counts) =>
  API.post("/country_actual_counts", { counts });

export const updateEnrollmentLetterReceived = (id, enrollment_letter_received, enrollment_letter_user) =>
  API.post("/enrollment_letter_received", { id, enrollment_letter_received, enrollment_letter_user });

export const getPendingEnrollmentLetters = (search, page) =>
  API.get("/enrollment_letters/pending", { params: { search, page } });

export const assignEnrollmentLetterUser = (id, assigned_user) =>
  API.post("/enrollment_letters/assign", { id, assigned_user });

export const markEnrollmentLetterPending = (id) =>
  API.post("/enrollment_letters/mark_pending", { id });

export const uploadEnrollmentLetter = (formData) =>
  API.post("/enrollment_letters/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const downloadEnrollmentLetter = (filename) =>
  API.get(`/enrollment_letters/download/${filename}`, { responseType: "blob" });

export const getEnrollmentLetterHistory = (search, page) =>
  API.get("/enrollment_letters/history", { params: { search, page } });

export const getEnrollmentLetterHistoryExport = (search) =>
  API.get("/enrollment_letters/history/export", { params: { search } });

export const searchStudentForEnrollmentLetter = (search) =>
  API.get("/enrollment_letters/search", { params: { search } });

export const confirmEnrollmentLetter = (id) =>
  API.post("/enrollment_letters/confirm", { id });

export const getEnrollmentLetterComments = (id) =>
  API.get(`/enrollment_letters/comments/${id}`);
export const addEnrollmentLetterComment = (id, comment) =>
  API.post("/enrollment_letters/comments", { id, comment });

export const scoreComment = (id, score_pending, score_pending_user) =>
  API.post("/score_comment", { id, score_pending, score_pending_user });

export const moeComment = (id, moe_pending, moe_pending_user) =>
  API.post("/moe_comment", { id, moe_pending, moe_pending_user });

export const aatcReviewComment = (id, aatc_review, aatc_review_user) =>
  API.post("/aatc_review_comment", { id, aatc_review, aatc_review_user });

export const deliveryHoldComment = (id, delivery_hold, delivery_hold_reason, delivery_hold_user) =>
  API.post("/delivery_hold_comment", { id, delivery_hold, delivery_hold_reason, delivery_hold_user });

export const moeHoldComment = (formData) =>
  API.post("/moe_hold_comment", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// school_location ("inside_egypt" / "outside_egypt") only matters for foreignUsd.
export const Act1crt = (id, school_location) => API.post("/printact1", { id, school_location });
export const Act2crt = (id, school_location) => API.post("/printact2", { id, school_location });
export const Amount = () => API.get("/amount");

export const submitTransfer = (data) => API.post("/transfer/submit", data);
export const getTransferSubmissions = () => API.get("/transfer/submissions");
export const doTransfer = (id, national_id) => API.patch(`/transfer/do/${id}`, { national_id });

// Reservations — public booking form (/reserve) and the slot calendar.
export const getPublicReservationSlots = () => API.get("/reservation/public/slots");
export const bookReservation = (data) => API.post("/reservation/public/book", data);
export const getReservationSlots = (from, to) =>
  API.get("/reservation/slots", { params: { from, to } });
// data = { categories, dates, start_time, end_time, capacity } — one slot per category × date.
export const createReservationSlots = (data) => API.post("/reservation/slots", data);
export const updateReservationSlot = (id, data) => API.put(`/reservation/slots/${id}`, data);
export const deleteReservationSlot = (id) => API.delete(`/reservation/slots/${id}`);
export const getSlotReservations = (id) => API.get(`/reservation/slots/${id}/bookings`);
export const cancelReservation = (id) => API.patch(`/reservation/bookings/${id}/cancel`);
// A reservation by the reference on its QR ticket (scan page).
export const getReservationByReference = (code) =>
  API.get(`/reservation/lookup/${encodeURIComponent(code)}`);
// Whether the public booking form is open (only admin can change it).
export const getReservationBookingStatus = () => API.get("/reservation/booking-status");
export const setReservationBookingStatus = (booking_open) =>
  API.put("/reservation/booking-status", { booking_open });

export const getSchools = () => API.get("/schools");
export const createSchool = (data) => API.post("/school", data);
export const updateSchool = (id, data) => API.put(`/school/${id}`, data);
export const deleteSchool = (id) => API.delete(`/school/${id}`);

export const createScoreSubmission = (data) =>
  API.post("/score_submission", data);
export const getScoreSubmissions = () => API.get("/score_submissions");
export const getAllScoreSubmissions = () => API.get("/score_submissions/all");
export const approveScoreSubmission = (id) =>
  API.post(`/score_submission/${id}/approve`);
export const managerApproveScoreSubmission = (id) =>
  API.post(`/score_submission/${id}/manager-approve`);
export const scoreFinishedSubmission = (id) =>
  API.post(`/score_submission/${id}/score-finished`);

export const getScoreReminderRecipients = () =>
  API.get("/score_reminder_recipients");
export const addScoreReminderRecipient = (email) =>
  API.post("/score_reminder_recipients", { email });
export const deleteScoreReminderRecipient = (id) =>
  API.delete(`/score_reminder_recipients/${id}`);
export const runScoreReminder = () => API.post("/score_reminder/run");

export const getRushReminderRecipients = () =>
  API.get("/rush_reminder_recipients");
export const addRushReminderRecipient = (email) =>
  API.post("/rush_reminder_recipients", { email });
export const deleteRushReminderRecipient = (id) =>
  API.delete(`/rush_reminder_recipients/${id}`);
export const runRushReminder = () => API.post("/rush_reminder/run");

export const getQrCodes = (page, search) =>
  API.get("/qrcodes", { params: { page, search } });
export const createQrCodeRange = (start, end) =>
  API.post("/qrcodes/range", { start, end });
export const markQrCodesUsed = (lastUsedCode, used_date) =>
  API.post("/qrcodes/mark_used", { lastUsedCode, used_date });
export const getQrCodesReport = () => API.get("/qrcodes/report");

export default API;
